import { forwardRef, useCallback, useMemo } from 'react'
import { bool, shape, instanceOf, string, func } from 'prop-types'

import { MaskedInput } from '../masked-input'

import s from './date-picker-input.module.scss'

const DatePickerInput = forwardRef(({ isAddonBeforeVisible, onChange, onCalendarIconClick, ...restProps }, ref) => {
  const addonAfter = useMemo(
    () => () =>
      (
        <button className={s['date-picker-icon-btn']} type="button" onClick={onCalendarIconClick}>
          <i className="bi bi-calendar text-dark" />
        </button>
      ),
    [onCalendarIconClick],
  )

  const handleChange = useCallback(value => onChange({ target: { value } }), [onChange])

  return <MaskedInput addonAfter={addonAfter} onChange={handleChange} {...restProps} />
})

DatePickerInput.propTypes = {
  isInvalid: bool,
  componentRef: shape({ current: instanceOf(Element) }),
  value: string,
  onChange: func,
  onCalendarIconClick: func,
  name: string,
}

export default DatePickerInput
